import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Company } from './models/company.model';

export interface CompanyState extends EntityState<Company> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'company', idKey: 'CompanyId', cache: { ttl: 20000 } })
export class CompanyStore extends EntityStore<CompanyState> {
  constructor() {
    super();
  }
}

